import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import CustomerLayout from './components/CustomerLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import StaffDashboard from './pages/StaffDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import CustomerBookings from './pages/CustomerBookings';
import CustomerServices from './pages/CustomerServices';
import CustomerInvoices from './pages/CustomerInvoices';
import CustomerReviews from './pages/CustomerReviews';
import CustomerSupport from './pages/CustomerSupport';
import CustomerProfile from './pages/CustomerProfile';
import Bookings from './pages/Bookings';
import Rooms from './pages/Rooms';
import Customers from './pages/Customers';
import Staff from './pages/Staff';
import StaffDetails from './pages/StaffDetails';
import Services from './pages/Services';
import Housekeeping from './pages/Housekeeping';
import Inventory from './pages/Inventory';
import Maintenance from './pages/Maintenance';
import Reports from './pages/Reports';
import UserManagement from './pages/UserManagement';
import Settings from './pages/Settings';
import NotificationsPage from './pages/NotificationsPage';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState('');

  const handleLogin = (role) => {
    setIsAuthenticated(true);
    setUserRole(role);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserRole('');
  };

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  // Customer Portal - Full customer experience
  if (userRole === 'Customer') {
    return (
      <CustomerLayout onLogout={handleLogout}>
        <Routes>
          <Route path="/customer" element={<CustomerDashboard />} />
          <Route path="/customer/bookings" element={<CustomerBookings />} />
          <Route path="/customer/services" element={<CustomerServices />} />
          <Route path="/customer/invoices" element={<CustomerInvoices />} />
          <Route path="/customer/reviews" element={<CustomerReviews />} />
          <Route path="/customer/support" element={<CustomerSupport />} />
          <Route path="/customer/profile" element={<CustomerProfile />} />
          <Route path="*" element={<Navigate to="/customer" replace />} />
        </Routes>
      </CustomerLayout>
    );
  }

  // Staff Portal - Limited access
  if (userRole === 'Staff') {
    return (
      <Layout userRole={userRole} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<StaffDashboard userRole={userRole} userName="Sarah Staff" />} />
          <Route path="/housekeeping" element={<Housekeeping />} />
          <Route path="/services" element={<Services />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    );
  }

  // Admin & Manager Portal - Full access
  return (
    <Layout userRole={userRole} onLogout={handleLogout}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/staff/:id" element={<StaffDetails />} />
        <Route path="/services" element={<Services />} />
        <Route path="/housekeeping" element={<Housekeeping />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Routes>
    </Layout>
  );
};

export default App;
